import React from 'react';
import { Avatar, Dropdown, Button, Space, Typography } from 'antd';
import { UserOutlined, LogoutOutlined, LoginOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import { usePermissions } from '../../contexts/PermissionContext';

const { Text } = Typography;

/**
 * UserProfile component
 * Displays user avatar, name, and role in the header
 * Provides login/logout functionality
 * Styled with the corporate design (green background)
 */
const UserProfile: React.FC = () => {
  const { userInfo, isAuthenticated, isLoading, login, logout } = useAuth();
  const { roles } = usePermissions();

  // Menu items for authenticated users
  const menuItems: MenuProps['items'] = [
    {
      key: 'logout',
      label: 'Cerrar sesión',
      icon: <LogoutOutlined />,
      onClick: logout,
    },
  ];

  if (isLoading) {
    return (
      <div style={{ padding: '0 16px' }}>
        <Avatar icon={<UserOutlined />} />
      </div>
    );
  }

  if (!isAuthenticated || !userInfo) {
    return (
      <Button
        type="primary"
        icon={<LoginOutlined />}
        onClick={login}
        style={{
          backgroundColor: '#025940',
          borderColor: '#025940',
        }}
      >
        Iniciar sesión
      </Button>
    );
  }

  return (
    <Dropdown menu={{ items: menuItems }} placement="bottomRight" arrow>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '4px 12px',
          backgroundColor: '#025940',
          borderRadius: '4px',
          cursor: 'pointer',
          transition: 'background-color 0.3s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#037a5a';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#025940';
        }}
      >
        {userInfo.photoUrl ? (
          <Avatar src={userInfo.photoUrl} size={32} />
        ) : (
          <Avatar icon={<UserOutlined />} size={32} />
        )}
        <Space direction="vertical" size={0} style={{ lineHeight: 1.2 }}>
          <Text
            strong
            style={{
              color: '#fff',
              fontSize: '14px',
              margin: 0,
            }}
          >
            {userInfo.name}
          </Text>
          <Text
            style={{
              color: '#fff',
              fontSize: '12px',
              opacity: 0.9,
            }}
          >
            ({roles.length > 0 ? roles[0] : 'Sin rol'})
          </Text>
        </Space>
      </div>
    </Dropdown>
  );
};

export default UserProfile;
